module.exports = __webpack_public_path__ + "img/user-red.0a47b448.svg";